export enum BikyAdviserEnum {
  UserId = '1ct1ltn7n159'
}
